import React, { Component } from "react";
import { Table, Pagination, Col, Row, Input, Select } from "antd";
import { strings } from "../../helpers";
import { Link } from "react-router-dom";
const { Search } = Input;
const { Option } = Select;

export default class NewsStatsView extends Component {
  render() {
    const { newsTypes } = this.props;

    const columns = [
      {
        title: "News type",
        key: "name",
        align: "left",
        render: record => <div>{record.name}</div>
      },
      {
        title: "Weekly status",
        key: "phone_number",
        align: "left",
        render: record => (
          <div>
            <div className="text-green">
              Published - {record.published_news}
            </div>
            <div className="text-red">
              Unpublished - {record.unpublished_news}
            </div>
          </div>
        )
      }
    ];
    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={24} className="heading-domain">
              Type of news
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              columns={columns}
              dataSource={newsTypes}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
      </div>
    );
  }
}
